import { Card, CardContent } from '../ui/card';
import { ShoppingCart, TrendingUp, Database, Globe2 } from 'lucide-react';

const CARDS = [
  {
    Icon: ShoppingCart,
    title: 'App + Retail Distribution',
    body: 'Sell through our consumer app AND partner retail stores across ANZ for maximum reach.',
    dark: true,
    iconBg: 'bg-white/20 backdrop-blur-sm',
  },
  {
    Icon: TrendingUp,
    title: 'Consumer Marketing',
    body: 'Direct visibility to end customers through our app and social media channels.',
    dark: false,
    iconBg: 'bg-gradient-to-br from-blue-500 to-blue-600',
  },
  {
    Icon: Database,
    title: 'Real-Time Intelligence',
    body: 'Get data on what sells, which pack sizes work, pricing sensitivity, and regional insights.',
    dark: true,
    iconBg: 'bg-white/20 backdrop-blur-sm',
  },
  {
    Icon: Globe2,
    title: 'Established Presence',
    body: 'Operations across every major territory in ANZ with local expertise and networks.',
    dark: false,
    iconBg: 'bg-gradient-to-br from-green-500 to-emerald-600',
  },
];

export const WhyAtlas = () => (
  <section id="why-atlas" className="py-20 md:py-32 bg-gray-50">
    <div className="container mx-auto px-6">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Why Atlas?</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto">
          We're not a traditional exporter. We're your strategic partner for market entry, distribution, and brand building.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {CARDS.map(({ Icon, title, body, dark, iconBg }) => (
          <Card
            key={title}
            className={dark
              ? 'border-0 bg-[#004aad] text-white card-lift hover:shadow-2xl transition-all duration-300'
              : 'border-2 border-gray-200 bg-white card-lift hover:shadow-2xl hover:border-[#004aad] transition-all duration-300'}
          >
            <CardContent className="pt-6">
              <div className={`h-16 w-16 ${iconBg} rounded-xl flex items-center justify-center mb-4`}>
                <Icon className={`h-8 w-8 text-white${dark ? ' fill-current' : ''}`} />
              </div>
              <h3 className={`text-xl font-bold mb-3 ${dark ? '' : 'text-gray-900'}`}>{title}</h3>
              <p className={dark ? 'text-white/90 leading-relaxed' : 'text-gray-600 leading-relaxed'}>{body}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);
